// Fuzzball Quiz Validators
// Form validation logic for all quiz steps

window.QuizValidators = {
  // Step-specific required fields
  requiredFields: {
    1: ['fuzzballer_name'],                       // only the name on page 1 post-funnel-trim
    2: ['wet_dry_preference'],
    3: [],  // cans_per_day validation handled in validateStep3 (Task 3.4)
    4: ['health_concerns_exists'],  // lifestyle + age conditional on food type (Task 3.5 + page-1-funnel)
    5: [],  // dislikes are optional
    6: ['customer_name', 'customer_email'],
    7: [] // Plan summary - no required fields
  },

  // Validate a specific step
  validateStep(step, data) {
    // For steps 1-5, validate all cats
    if (step >= 1 && step <= 5) {
      const catCount = data.catCount || 1;
      
      for (let i = 1; i <= catCount; i++) {
        const catData = data[`cat${i}`];
        if (!catData) {
          return false;
        }
        
        const required = this.requiredFields[step] || [];
        
        // Check basic required fields for this cat
        for (const field of required) {
          if (!this.validateField(field, catData[field])) {
            return false;
          }
        }
        
        // Special validation for specific steps
        switch (step) {
          case 1:
            if (!this.validateStep1(catData)) return false;
            break;
          case 3:
            if (!this.validateStep3(catData)) return false;
            break;
          case 4:
            if (!this.validateStep4(catData)) return false;
            break;
        }
      }
      
      return true;
    } else {
      // For steps 6-7, validate global data
      const required = this.requiredFields[step] || [];
      
      // Check basic required fields
      for (const field of required) {
        if (!this.validateField(field, data[field])) {
          return false;
        }
      }
      
      // Special validation for specific steps
      switch (step) {
        case 6:
          return this.validateStep6(data);
        default:
          return true;
      }
    }
  },

  // Validate individual field
  validateField(fieldName, value) {
    // Handle different field types
    switch (fieldName) {
      case 'fuzzballer_name':
      case 'customer_name':
        return this.validateText(value, 1, 50);
      
      case 'customer_email':
        return this.validateEmail(value);
      
      case 'disliked_flavors':
        return true; // Optional field, always valid
      
      default:
        // For radio buttons and selects, just check if value exists
        return !this.isEmpty(value);
    }
  },

  // Step 1 specific validation
  validateStep1(data) {
    // All step 1 fields are required (handled by requiredFields)
    return true;
  },

  // Step 3 specific validation (quantity)
  validateStep3(data) {
    // cans_per_day only required for Wet and Both, not Dry
    if (data.wet_dry_preference !== 'Dry' && !data.cans_per_day) {
      return false;
    }
    return true;
  },

  // Step 4 specific validation (health & lifestyle & age)
  validateStep4(data) {
    // Lifestyle only required for Dry path
    if (data.wet_dry_preference === 'Dry' && !data.lifestyle) {
      return false;
    }

    // Age required when food preference is Dry or Both (matches the conditional reveal on step 4)
    if ((data.wet_dry_preference === 'Dry' || data.wet_dry_preference === 'Both') && !data.age_range) {
      return false;
    }

    // If health concerns exist, specific concern must be selected
    if (data.health_concerns_exists === 'Yes') {
      if (!data.health_concerns || data.health_concerns === '') {
        return false;
      }
    }

    return true;
  },

  // Step 6 specific validation
  validateStep6(data) {
    // Validate name exists
    if (!this.validateText(data.customer_name, 1, 50)) {
      return false;
    }

    // Validate email format
    if (!this.validateEmail(data.customer_email)) {
      return false;
    }

    return true;
  },

  // Validate all steps at once
  validateAllSteps(data) {
    // Validate steps 1-5 for all cats
    for (let step = 1; step <= 5; step++) {
      if (!this.validateStep(step, data)) {
        return false;
      }
    }
    
    // Validate steps 6-7 (global data)
    for (let step = 6; step <= 7; step++) {
      if (!this.validateStep(step, data)) {
        return false;
      }
    }
    
    return true;
  },

  // Helper validation methods
  isEmpty(value) {
    if (value === null || value === undefined || value === '') return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === 'object' && Object.keys(value).length === 0) return true;
    return false;
  },

  validateText(value, minLength = 1, maxLength = 100) {
    if (this.isEmpty(value)) return false;
    const trimmed = value.trim();
    return trimmed.length >= minLength && trimmed.length <= maxLength;
  },

  validateEmail(email) {
    if (this.isEmpty(email)) return false;
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email.trim());
  },

  validateNumber(value, min, max) {
    const num = parseFloat(value);
    return !isNaN(num) && num >= min && num <= max;
  },

  // Get validation message for field
  getValidationMessage(fieldName) {
    const messages = {
      fuzzballer_name: "Please enter your cat's name",
      age_range: "Please select your cat's age range",
      breed: "Please select your cat's breed",
      wet_dry_preference: "Please select food preference",
      cans_per_day: "Please select how many cans per day",
      health_concerns_exists: "Please indicate if your cat has health concerns",
      health_concerns: "Please select the specific health concern",
      lifestyle: "Please select your cat's lifestyle",
      customer_name: "Please enter your name",
      customer_email: "Please enter a valid email address"
    };

    return messages[fieldName] || "This field is required";
  },

  // Validate form element directly
  validateFormElement(element) {
    const fieldName = element.name;
    const value = element.type === 'checkbox' ? 
      Array.from(document.querySelectorAll(`[name="${fieldName}"]:checked`)).map(cb => cb.value) :
      element.value;

    const isValid = this.validateField(fieldName, value);
    
    // Add/remove error classes
    if (isValid) {
      element.classList.remove('error');
      const errorMsg = element.parentElement.querySelector('.error-message');
      if (errorMsg) errorMsg.remove();
    } else { 
      element.classList.add('error');
      this.showFieldError(element, this.getValidationMessage(fieldName));
    }

    return isValid;
  },

  // Show error message for field
  showFieldError(element, message) {
    // Remove existing error message
    const existingError = element.parentElement.querySelector('.error-message');
    if (existingError) existingError.remove();

    // Create new error message
    const errorMsg = document.createElement('span');
    errorMsg.className = 'error-message';
    errorMsg.textContent = message;
    errorMsg.style.cssText = 'color: #ef4444; font-size: 0.875rem; margin-top: 0.25rem;';
    
    element.parentElement.appendChild(errorMsg);
  },

  // Clear all validation errors
  clearErrors() {
    document.querySelectorAll('.error').forEach(el => el.classList.remove('error'));
    document.querySelectorAll('.error-message').forEach(el => el.remove());
  },

  // Get fields that need validation for current step
  getFieldsForStep(step) {
    const fields = [...(this.requiredFields[step] || [])];
    
    // Add conditional fields
    if (step === 4) {
      fields.push('health_concerns');
    } else if (step === 5) {
      fields.push('disliked_flavors');
    }

    return fields;
  }
};